<template>
    <div
        class="w-100 user-list py-2 px-2 d-block"
        v-if="
            (unidade != undefined &&
                ($store.state.user.unidade.id != 1 && unidade.id <= 3
                    ? false
                    : true)) ||
            unidade.unread > 0
        "
    >
        <div class="unidade d-flex flex-row justify-content-between">
            <b class="name">
                <i
                    v-if="selected"
                    class="mdi mdi-chevron-right-circle text-primary"
                ></i>
                {{ unidade.nome }}
            </b>
            <span>
                <span
                    class="unread mx-2"
                    v-if="unidade.unread && unidade.unread > 0"
                >
                    {{ unidade.unread }}
                </span>
                <span v-for="unidadeID in userUnidadeOnline" :key="unidadeID">
                    <span
                        v-if="unidadeID == unidade.id"
                        class="availability-status online"
                    >
                        <i class="fa fa-circle" aria-hidden="true"></i>
                    </span>
                </span>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        unidade: {
            type: Object,
        },
        online: { type: Boolean, default: false },
        selected: { type: Boolean, default: false },
    },
    computed: {
        userUnidadeOnline() {
            return [
                ...new Set(
                    this.$store.state.users.map((item) => item.unidadeID)
                ),
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
.unread {
    background: #fb8994;
    color: #fff;
    right: 11px;
    min-width: 20px;
    /* top: 20px; */
    align-items: center;
    line-height: 20px;
    font-size: 12px;
    padding: 0 4px;
    /* float: right; */
    z-index: 1010;
    /* position: absolute; */
    text-align: center;
    border-radius: 10px;
}
.availability-status {
    font-size: 8px;
}
.availability-status.online {
    color: #1bcfb4;
}
.availability-status .offline {
    background: #ccc;
}
</style>
